import { render, staticRenderFns } from "./image-modal.vue?vue&type=template&id=3b9026c7&scoped=true"
import script from "./image-modal.vue?vue&type=script&lang=js"
export * from "./image-modal.vue?vue&type=script&lang=js"
import style0 from "./image-modal.vue?vue&type=style&index=0&id=3b9026c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9026c7",
  null
  
)

export default component.exports